import { Skeleton } from "antd";

export const SkeletonLoading = () => (
  <div style={{display: 'flex', flexDirection: 'column', gap: '1rem', width: '100%', padding: '2rem'}}>
    <Skeleton.Input
      active={true}
      style={{ height: "3rem", width: "100%", borderRadius: "1rem" }}
    />
    <Skeleton.Input
      active={true}
      style={{ height: "3rem", width: "100%", borderRadius: "1rem" }}
    />
    <Skeleton.Input
      active={true}
      style={{ height: "3rem", width: "100%", borderRadius: "1rem" }}
    />
    <Skeleton.Input
      active={true}
      style={{ height: "3rem", width: "100%", borderRadius: "1rem" }}
    />
     <Skeleton.Input
      active={true}
      style={{ height: "3rem", width: "100%", borderRadius: "1rem" }}
    />
     <Skeleton.Input
      active={true}
      style={{ height: "3rem", width: "100%", borderRadius: "1rem" }}
    />
     <Skeleton.Input
      active={true}
      style={{ height: "3rem", width: "100%", borderRadius: "1rem" }}
    />
  </div>
);
